import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=853448a0&scoped=true"
import script from "./main-header.vue?vue&type=script&lang=ts"
export * from "./main-header.vue?vue&type=script&lang=ts"
import style0 from "./main-header.vue?vue&type=style&index=0&id=853448a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853448a0",
  null
  
)

export default component.exports